import React, { useRef, useState } from 'react'

import { ToggleIcon, Collapse, Spinner } from '@pb/components'
import { useScrollTo } from '@pb/utils'
import cn from 'classnames'

import styles from './PurchaseCore.scss'

const PurchaseCore: React.FC<any> = ({
  orderId,
  expandedOrderId,
  toggleExpandedOrder,
  shouldShowSpinner,
  shouldWrapContent,
  className,
  iterator,
  isVisible,
  header,
  headerClassName,
  disabled,
  children,
}) => {
  const [shouldScrollToElement, setShouldScrollToElement] = useState(false)
  const purchaseElement = useRef(null)
  const isExpanded = orderId === expandedOrderId

  useScrollTo({ shouldScroll: shouldScrollToElement, ref: purchaseElement })

  const style =
    isVisible !== undefined
      ? {
          opacity: Number(isVisible),
          transitionDelay: `${(iterator + 1) * 75}ms`,
        }
      : {
          animation: `${styles.fadeIn} 1s linear forwards ${(iterator + 1) * 75}ms`,
        }

  const getToggleClasses = (): any => {
    const toggleClasses = [styles.purchaseHeader]

    if (shouldShowSpinner) {
      toggleClasses.push(styles.blurred)
    }

    if (headerClassName && typeof headerClassName === 'string') {
      headerClassName.split(' ').forEach((stylingClass) => toggleClasses.push(stylingClass)) // Because preserved words!
    }

    return toggleClasses
  }

  const handleAnimationEnd = (): any => {
    setShouldScrollToElement(isExpanded)
  }

  const renderChildren = (): any => {
    if (typeof children === 'function') {
      children()
    }

    return children
  }

  const renderPurchaseHeader = (): any => (
    <>
      {header}
      <ToggleIcon isExpanded={isExpanded} className={styles.toggleIcon} />
    </>
  )

  const renderContent = (): any => {
    const content = (
      <Collapse
        toggleContent={renderPurchaseHeader}
        toggleClassNames={getToggleClasses()}
        isExpanded={isExpanded}
        onClick={toggleExpandedOrder}
        onAnimationEnd={handleAnimationEnd}
        buttonTestID="purchaseButton"
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: any; toggleContent: () => any; t... Remove this comment to see the full error message
        disabled={disabled}
        controlled
      >
        {renderChildren()}
      </Collapse>
    )

    if (shouldWrapContent && shouldShowSpinner) {
      return (
        <div data-contentwrapper data-testid="purchaseContentWrapper">
          {content}
        </div>
      )
    }

    return content
  }
  return (
    <li
      ref={purchaseElement}
      id={`purchase-${orderId}`}
      className={cn('test', styles.container, className, {
        [styles.isExpanded]: isExpanded,
      })}
      style={style}
    >
      <Spinner
        data-testid="loadingSpinner"
        containerClassName={styles.loadingSpinner}
        isRendered={shouldShowSpinner}
      />

      {renderContent()}
    </li>
  )
}

export default PurchaseCore
